import Vue from "vue";

interface ToDoBusInterface {
    $emit(event: 'reload:toDos'): void;
    $on(event: 'reload:toDos', callback: () => void): any;
    $off(event: 'reload:toDos', callback?: () => void): any;
}

export const ToDoBus: ToDoBusInterface = new Vue();
